import React from "react";

export interface SignUpProps {}

const SignUp: React.FC<SignUpProps> = () => {
	return <> Sign Up</>;
};

export default SignUp;
